import React from "react";

export interface ICustomerProfilePageProps {}

const CustomerProfileIndexPage: React.FC<ICustomerProfilePageProps> = (_props) => {
  return <div className="flex justify-center items-center flex-col w-full h-full">Customer Profile Index Page</div>;
};

export default CustomerProfileIndexPage;
